/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { ApiStatus } from '../../../ts';
import { TWO_MINUTES } from './config';

/**
 * Redux Async Status.
 * @deprecated Use `ApiStatus` instead.
 */
export const STATUS = {
  IDLE: ApiStatus.IDLE,
  LOADING: ApiStatus.LOADING,
  SUCCEEDED: ApiStatus.SUCCEEDED,
  ERROR: ApiStatus.ERROR
};

export const LOADER_STATES = {
  INACTIVE: 'inactive',
  ACTIVE: 'active',
  ERROR: 'error',
  SUCCESS: 'finished'
};

/**
 * returns true if `lastFetched` exists and is expired compared to `ttl`
 * @param {*} lastFetched The date to check if expired
 * @param {*} ttl The time to live
 * @returns {Boolean} True if expired otherwise false
 */
export const isCacheExpired = (lastFetched?: number, ttl = TWO_MINUTES) =>
  !lastFetched || Date.now() - lastFetched > ttl;
